import Button from '../../Common/Button';
import columnOrder from '../../../../../src/assets/img/svg/buttons/columnOrder.svg';
import { useRef, useState } from 'react';
import { t } from 'i18next';
import ColumnOrderDropdown from './ColumnOrderDropdown';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { useCloseOnScrollAndClickOutside } from '../../../../hook/useCloseOnScrollAndClickOutside';

const ColumnOrder: React.FC = () => {
  const [openColumnOrder, setColumnOrder] = useState(false);

  const isMobile = useAppSelector((state) => state.configSlice.isMobile);
  const menuRef = useRef<HTMLDivElement>(null);

  const openColumnOrderDropdown = () => {
    setColumnOrder((prevState) => !prevState);
  };

  useCloseOnScrollAndClickOutside(setColumnOrder, menuRef);

  return (
    <div className="column_order_wrapper">
      <div ref={menuRef}>
        <Button
          icon={columnOrder}
          onClick={openColumnOrderDropdown}
          variant={`${openColumnOrder ? 'filled' : ''}`}
          className="column_order_button"
        >
          {(openColumnOrder || isMobile) && (
            <span className="button_name">{t('statisticPage.header.buttons.columnOrder')}</span>
          )}
        </Button>
        <ColumnOrderDropdown showDropdown={openColumnOrder} setShowDropdown={setColumnOrder} />
      </div>
    </div>
  );
};

export default ColumnOrder;
